module.exports = __webpack_public_path__ + "static/the-russia-hoax-d311856d5f7d7dcd62fac091c9f0d80a.jpg";